import React from 'react'

import {ConnectButton} from '@rainbow-me/rainbowkit'
import {useTranslation} from '@lib/intl/useTranslations'
import {IGlobalNavigationStyles} from '@component/header/GlobalNavigation/GlobalNavigation'

import Text from '@component/Text/Text'
import WalletIcon from '@pages/wallet/components/WalletIcon'

import IconDown from '@svg/common/ic_btn_down.svg'

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
    navStyles?: IGlobalNavigationStyles
    navTheme?: 'light' | 'dark'
    enableFloatingNavigation?: boolean
}

const NavigationWalletOperation = ({className, navStyles, navTheme, enableFloatingNavigation}: IProps) => {
    const t = useTranslation()
    return (
        <ConnectButton.Custom>
            {({account, chain, openAccountModal, openConnectModal, authenticationStatus, mounted}) => {
                const ready = mounted && authenticationStatus !== 'loading'
                const connected =
                    ready && account && chain && (!authenticationStatus || authenticationStatus === 'authenticated')

                if (connected && chain?.unsupported) return null
                return (
                    <div className={className}>
                        <div className={!ready ? 'opacity-0 pointer-events-none user-select-none hidden' : ''}>
                            <button
                                type="button"
                                className={`flex items-center gap-x-[5px] py-[4px] px-[9px] border rounded-full ${
                                    navStyles?.logoType === 'white'
                                        ? 'border-dark_gray07 bg-bg_dark_white03'
                                        : 'border-gray07 dark:border-dark_gray07 bg-transparent dark:bg-bg_dark_white02'
                                }`}
                                onClick={!connected ? openConnectModal : openAccountModal}>
                                <span className={`w-[16px] h-[16px] ${connected ? '' : 'sm:hidden'}`}>
                                    <WalletIcon darkOnly={navStyles?.logoType === 'white' && navTheme === 'dark'} />
                                </span>

                                {!connected && (
                                    <Text className={`text-btn_sm ${navStyles?.TextPrimaryColor}`}>
                                        {t('common.connect.wallet')}
                                    </Text>
                                )}

                                {connected && !chain?.unsupported && (
                                    <div className={'flex items-center gap-x-[3px] group'}>
                                        <Text className={`text-btn_sm ${navStyles?.TextPrimaryColor} sm:hidden`}>
                                            {account?.displayName}
                                        </Text>
                                        <IconDown
                                            className={`w-[10px] h-[10px]  ${
                                                navStyles?.logoType === 'white'
                                                    ? 'fill-dark_gray01'
                                                    : 'fill-gray01 dark:fill-dark_gray01'
                                            } group-hover:-rotate-180 transition-transform`}
                                        />
                                    </div>
                                )}
                            </button>
                        </div>
                    </div>
                )
            }}
        </ConnectButton.Custom>
    )
}
export default React.memo(NavigationWalletOperation)
